// tslint:disable:interface-over-type-literal
// tslint:disable:max-line-length

import { ITCIValidationError, ITCIFieldValidationResult } from "./tci-validation";
import { strEnum } from "../../types";
import { Observable } from "rxjs";
import {ITCIApplication, TCITenantAppType} from "./tci-application";

/**
 * interface ITCIModelService
 * This interface provide common functions for the TCI Model
 */
export interface ITCIModelService {
    /**
     * Returns TCI Applications from all tenants
     */
    getApplications(): Observable<ITCIApplication>;

}

/**
 * Contribution type enumeration
 * @type {{[K in string|string|string|string]:K}}
 */
export const TCI_CONTRIBUTION_TYPE = strEnum(["connector"]);
export type TCI_CONTRIBUTION_TYPE = keyof typeof TCI_CONTRIBUTION_TYPE;

/**
 * Contribution type converter from string types
 */
export class ContributionTypeConverter {
    public static fromString(val: string): TCI_CONTRIBUTION_TYPE {
        if (val === "tci:connector") {
            return TCI_CONTRIBUTION_TYPE.connector;
        }
    }

    public static toString(ctype: TCI_CONTRIBUTION_TYPE): string {
        return "tci:" + ctype;
    }
}

/**
 * MODULE_CONTRIBUTION type
 * @typeparam T  The generic type parameter indicating the value type being returned
 * @private
 */
export type TCI_MODULE_CONTRIBUTION<T> = {
    name: string;
    type: TCI_CONTRIBUTION_TYPE;
    route: string;
    routePath: string;
    files: string[];
    service: T,
    jsonData: any,
    provider: TCITenantAppType
};


/**
 * TCI_CONTRIBUTION_LOAD_RESULT type
 * @private
 */
export type TCI_CONTRIBUTION_LOAD_RESULT = { status: string, data: any };

/**
 * Contribution UI modes
 */
export enum CONTRIB_UI_MODE {
    WIZARD,
    PALETTE
}

/**
 * The UI form sends the IContributionContext
 */
export interface ITCIContributionContext {
    changelist?: string[];
    appId?: string;
    currentFlowName?: string;

    hashTags?: string[];

    /**
     * Returns the mode whether it is from Wizard or palette.
     */
    getMode(): CONTRIB_UI_MODE;

    /**
     * Returns the flowname for the given context
     */
    getCurrentFlowName(): string;
}

/**
 * Union Type from all contribution types
 */
export type ITCIContributionTypes =
    ITCIContributionContext
    | ITCIConnectorContribution;

/**
 * interface Validation provider
 */
export interface IContribValidationProvider {
    /**
     * validate
     * @param {IContributionTypes} context
     * @return {Observable<ITCIFieldValidationResult>}
     */
    validate(context: ITCIContributionTypes): ITCIFieldValidationResult | Observable<ITCIFieldValidationResult>;
}

/**
 * interface Field Provider
 */
export interface ITCIContribFieldProvider {

    /**
     * Gets Field Value
     * @param {ITCIContributionTypes} context
     * @return {any | Observable<any>}
     */
    getFieldValue(context: ITCIContributionTypes): any | Observable<any>;
}

/**
 * interface Action handler provider
 */
export interface ITCIContribActionProvider {
    /**
     * handle action
     *
     * @typeparam T  The generic type parameter indicating the value type being returned.
     * @param {IContributionTypes} context
     * @return {Observable<any> | any}
     */
    handleAction(context: ITCIContributionTypes): any | Observable<any>;
}

/**
 * interface remove  provider
 */
export interface ITCIContribRemoveProvider {

    /**
     * handle remove
     *
     * @typeparam T  The generic type parameter indicating the value type being returned.
     * @param {IContributionTypes} context
     * @return {Observable<any> | any}
     */
    handleRemove(context: ITCIContributionTypes): ITCIActionResult | Observable<ITCIActionResult>;

}

/**
 * interface Validation provider
 */
export interface ITCIContribValidationProvider {
    /**
     * validate
     * @param {IContributionTypes} context
     * @return {Observable<ITCIFieldValidationResult>}
     */
    validate(context: ITCIContributionTypes): ITCIFieldValidationResult | Observable<ITCIFieldValidationResult>;
}

/**
 * interface Field Provider
 */
export interface IContribFieldProvider {

    /**
     * Gets Field Value
     * @param {IContributionTypes} context
     * @return {any | Observable<any>}
     */
    getFieldValue(context: ITCIContributionTypes): any | Observable<any>;
}

/**
 * interface Action handler provider
 */
export interface IContribActionProvider {
    /**
     * handle action
     *
     * @typeparam T  The generic type parameter indicating the value type being returned.
     * @param {IContributionTypes} context
     * @return {Observable<any> | any}
     */
    handleAction(context: ITCIContributionTypes): any | Observable<any>;
}

/**
 * interface remove  provider
 */
export interface ITCIContribRemoveProvider {

    /**
     * handle remove
     *
     * @typeparam T  The generic type parameter indicating the value type being returned.
     * @param {IContributionTypes} context
     * @return {Observable<any> | any}
     */
    handleRemove(context: ITCIContributionTypes): ITCIActionResult | Observable<ITCIActionResult>;

}


/**
 *  Contribution Handler interface
 *
 * @description A comtribution handler implementation provides the following handlers
 *  * value - value provider for the given field
 *  * validate - vrules provider for the given field
 *  * action - action handler for a given button.
 */
export interface ITCIContributionHandler {
    /**
     *  @description Provide values for a specified field name parameter
     *  ## Simple Example
     *
     * @example
     * Here is an example of a field value provider class that can be injected:
     *
     * ```
     *
     *    @Injectable()
     *   export class RestContributionHandler extends WiServiceHandlerContribution {
     *   constructor(injector: Injector, http: Http) {
     *     super(injector, http);
     *  }
     *
     *  value = (fieldName: string, context: IActivityContribution): Observable<any> | any => {
     *    return Observable.create(observer => {
     *          observer.next("");
     *    });
     *  }
     *
     * }
     * ```
     * @param fieldName {{string}}
     * @param context {{IContributionTypes}}
     * @return {{Observable<any> | any}}
     */
    value: (fieldName: string, context: ITCIContributionTypes) => Observable<any> | any;
    /**
     * @description Validate a specified field name parameter
     *
     * @example
     * ## Simple Example
     *
     * Here is an example of a field value provider class that can be injected:
     *
     * ```
     *
     *    @Injectable()
     *   export class RestContributionHandler extends WiServiceHandlerContribution {
     *   constructor(injector: Injector, http: Http) {
     *     super(injector, http);
     *  }
     * ...
     *  validate = (fieldName: string, context: IActivityContribution): Observable<IValidationResult> | IValidationResult => {
     *   return Observable.create(observer => {
     *       let vresult: IValidationResult = ValidationResult.newValidationResult();
     *        observer.next(vresult);
     *    });
     *  }
     *
     * }
     * * ```
     * @param fieldName {{string}}
     * @param context {{IContributionTypes}}
     * @return {{Observable<IValidationResult> | IValidationResult}}
     */
    validate: (fieldName: string, context: ITCIContributionTypes) => Observable<ITCIFieldValidationResult> | ITCIFieldValidationResult;
    /**
     * @description Optional action handler for form buttons
     *
     * @example
     * ## Simple Example
     *
     * Here is an example of a field value provider class that can be injected:
     *
     * ```
     *
     *    @Injectable()
     *   export class RestContributionHandler extends WiServiceHandlerContribution {
     *   constructor(injector: Injector, http: Http) {
     *     super(injector, http);
     *  }
     *
     * ...
     *  action = (actionId: string, context: IActivityContribution): Observable<IActionResult> | IActionResult => {
     *    return Observable.create(observer => {
     *        let aresult: IActionResult = ActionResult.newActionResult();
     *        observer.next(aresult);
     *    });
     *   }
     * }
     * ```
     * @param actionId {{string}}
     * @param context {{IContributionTypes}}
     * @return {{Observable<IActionResult> | IActionResult}}
     */
    action?: (actionId: string, context: ITCIContributionTypes) => Observable<ITCIActionResult> | ITCIActionResult;
    /**
     * @description Optional remove handler for handling cleanup actions on external domains, invoked when the contribution
     * instance is deleted. The key information for delete comes from the context itself.
     * @example
     * ## Simple Example
     *
     * Here is an example of a field value provider class that can be injected:
     *
     * ```
     *
     *    @Injectable()
     *   export class MyConnectionHandler extends WiServiceHandlerContribution {
     *   constructor(injector: Injector, http: Http) {
     *     super(injector, http);
     *  }
     *
     * ...
     *  remove = (context: IConnectorContribution): Observable<IActionResult> | IActionResult => {
     *    return Observable.create(observer => {
     *        let aresult: IActionResult = ActionResult.newActionResult();
     *        observer.next(aresult);
     *    });
     *   }
     * }
     * ```
     * @param {IContributionTypes} context
     * @return {Observable<IActionResult> | IActionResult}
     */
    remove?: (context: ITCIContributionTypes) => Observable<ITCIActionResult> | ITCIActionResult;
}

/**
 * The result of any button action is return values.
 */
export interface ITCIActionResult {
    /**
     * property hold status if the action was a success or a failure
     */
    success: boolean;
    /**
     * if the action is a failure then any associated errors are returned.
     * OR Authentication Results OR any
     */
    result: ITCIValidationError | ITCIAuthenticationResult | any;

    /**
     *  getter function of [[success]] property
     * @return {boolean}
     */
    isSuccess(): boolean;

    /**
     * property setter for [[success]]
     * @param {boolean} state
     * @return {IActionResult}
     */
    setSuccess(state: boolean): ITCIActionResult;

    /**
     * property setter for [[result]]
     * @param {IValidationError | IAuthenticationResult | any} data
     * @return {IActionResult}
     */
    setResult(data: ITCIValidationError | ITCIAuthenticationResult | any): ITCIActionResult;

    /**
     * property getter for [[result]]
     * @return {IValidationError | IAuthenticationResult | any}
     */
    getResult(): ITCIValidationError | ITCIAuthenticationResult | any;
}


/**
 * Represents the Authentication Result data structure returned by the
 * connector contribution developer when a OAUTH login action is invoked from the
 * connector form buttons defined in connector.json
 *
 * The {{IAuthenticationResult}} is returned with the {{IActionResult}} result
 * parameter.
 */
export interface ITCIAuthenticationResult {
    /**
     * The {{AUTHENTICATION_TYPE}} being used for the action result
     */
    authType: AUTHENTICATION_TYPE;
    /**
     * The contribution context being used in the action handler OR provider
     */
    context: ITCIConnectorContribution;
    /**
     * Depending on {{AUTHENTICATION_TYPE}} authData will hold different
     * types of Data Interfaces.
     *  * {{AUTHENTICATION_TYPE.BASIC}} : {{IBasicAuthData}}
     *  * {{AUTHENTICATION_TYPE.OAUTH1}} : {{IOAuthData}}
     *  * {{AUTHENTICATION_TYPE.OAUTH2}} : {{IOAuthData}}
     *  * {{AUTHENTICATION_TYPE.OAUTH2_TWOLEG}} : {{IOAuthData}}
     */
    authData?: IOAuthData | IBasicAuthData;

}

/**
 * AuthenticationResult implementation
 */
export class AuthenticationResult implements ITCIAuthenticationResult {
    authType: AUTHENTICATION_TYPE;
    context: ITCIConnectorContribution;
    authData?: IOAuthData;

    /**
     * static constructor
     * @param {AUTHENTICATION_TYPE} atype
     * @return {IAuthenticationResult}
     */
    static newAuthenticationResult(atype: AUTHENTICATION_TYPE): ITCIAuthenticationResult {
        return new AuthenticationResult(atype);
    }

    /**
     * constructor
     * @param {AUTHENTICATION_TYPE} atype
     */
    private constructor(atype: AUTHENTICATION_TYPE) {
        this.authType = atype;
    }

    /**
     * @desc Returns the Connector contribution JSON object which has the
     * whole connection context object passed to the Handler or Provider
     * and gives the connector contribution mechanism to identify the connection
     * instance being created.
     * @return {IConnectorContribution}
     */
    getContext(): ITCIConnectorContribution {
        return this.context;
    }

    /**
     * @desc Sets the connection context object passed to the Handler or Provider
     * and gives the connector contribution mechanism to identify the connection
     * @param {IConnectorContribution} ctx
     */
    setContext(ctx: ITCIConnectorContribution) {
        this.context = ctx;
    }

    /**
     * Returns the Authentication Data Object {{IOAuthData}} which holds the information for {AUTHENTICATION_TYPE.BASIC}
     * OR
     * Returns the Authentication Data Object {{IOAuthData}} which holds
     * the information for {AUTHENTICATION_TYPE.OAUTH1} | {AUTHENTICATION_TYPE.OAUTH2} |{AUTHENTICATION_TYPE.OAUTH2_TWOLEG}
     * type authentication mechanisms. The contribution developer needs to provide this information based on which
     * the contribution mechanism will introspect the callback return state information. It is not assumed that every authentication
     * type will not have this information requirement as it may not involve a callback. In case of OAUTH type authentication
     * it is also not assumed that the state information is available by introspecting a fixed parameter name e.g. "state" so
     * the contribution developer need to provide this based on the SAAS authentication provider specifications.
     * @return {IOAuthData} | {IBasicAuthData}
     */
    getAuthData(): IOAuthData | IBasicAuthData {
        return this.authData;
    }

    /**
     * Sets the Authentication Data Object {{IOAuthData}} which holds the information for {AUTHENTICATION_TYPE.BASIC}
     * OR
     * Sets the Authentication Data Object {{IOAuthData}} which holds
     * the information for {AUTHENTICATION_TYPE.OAUTH1} | {AUTHENTICATION_TYPE.OAUTH2} |{AUTHENTICATION_TYPE.OAUTH2_TWOLEG}
     * type authentication mechanisms. The contribution developer needs to provide this information based on which
     * the contribution mechanism will introspect the callback return state information. It is not assumed that every authentication
     * type will not have this information requirement as it may not involve a callback. In case of OAUTH type authentication
     * it is also not assumed that the state information is available by introspecting a fixed parameter name e.g. "state" so
     * the contribution developer need to provide this based on the SAAS authentication provider specifications.
     * @param {IOAuthData} data
     */
    setAuthData(data: IOAuthData) {
        this.authData = data;
    }

}

/**
 * Represents the OAUTH data structure in {{IAuthenticationResult}} returned by the
 * connector contribution developer when a OAUTH login action is invoked from the
 * connector form buttons defined in connector.json
 *
 * Authentication Data Structure if {AUTHENTICATION_TYPE} is
 *  * {AUTHENTICATION_TYPE.BASIC}
 */
export interface IBasicAuthData {
    data: string;
}

/**
 * Represents the OAUTH data structure in {IAuthenticationResult} returned by the
 * connector contribution developer when a OAUTH login action is invoked from the
 * connector form buttons defined in connector.json
 *
 * Authentication Data Structure if {AUTHENTICATION_TYPE} is
 *  * {AUTHENTICATION_TYPE.OAUTH1}
 *  * {AUTHENTICATION_TYPE.OAUTH2}
 *  * {AUTHENTICATION_TYPE.OAUTH2_TWOLEG}
 */
export interface IOAuthData {
    /**
     * Authentication Login URL provided by the Connector without any state information parameters
     * @example https://login.salesforce.com/services/oauth2/authorize?response_type=code&client_id=CLIENTID&redirect_uri=REDIRECTURL&display=popup&prompt=login consent
     *  where REDIRECT_URL=https://localdev-integration.cloud.tibco.com/wistudio/connectiondetails
     *  NOTE: state information parameter for Salesforce "state" is not part of the URL
     */
    authLoginUrl: string;
    /**
     * This property will tell the Contribution Model what is the state information parameter name being used by the OAUTH provider
     * to return state of the Application before making the authentication request to the SAAS authentication provider.
     * @example For Saleforce the state information parameter is "state"
     */
    authStateQueryParam: string;
}

/**
 * IOAuthData implementation
 * @desc Helper class to create {{IOAuthData}} objects
 */
export class OAuthData implements IOAuthData {
    authLoginUrl: string;
    authStateQueryParam: string;

    /**
     * static constructor
     * @param {string} url
     * @param {string} stateQueryParam
     * @return {OAuthData}
     */
    static newOAuthData(url: string, stateQueryParam: string) {
        return new OAuthData(url, stateQueryParam);
    }

    /**
     * constructor
     * @param {string} url
     * @param {string} stateQueryParam
     */
    private constructor(url: string, stateQueryParam: string) {
        this.authLoginUrl = url;
        this.authStateQueryParam = stateQueryParam;
    }

    /**
     * @desc Returns the Authentication Login URL provided by the Connector without any state information parameters
     * @example https://login.salesforce.com/services/oauth2/authorize?response_type=code&client_id=CLIENTID&redirect_uri=REDIRECTURL&display=popup&prompt=login consent
     *  where REDIRECT_URL=https://localdev-integration.cloud.tibco.com/wistudio/connectiondetails
     *  NOTE: state information parameter for Salesforce "state" is not part of the URL
     * @return {string}
     */
    getAuthLoginURL(): string {
        return this.authLoginUrl;
    }

    /**
     * Returns the property which tells the Contribution Model what is the state information parameter name being used by the OAUTH provider
     * to return state of the Application before making the authentication request to the SAAS authentication provider.
     * @example For Saleforce the state information parameter is "state"
     * @return {string}
     */
    getAuthStateQueryParam(): string {
        return this.authStateQueryParam;
    }
}

export const MetaDataFieldType = strEnum(["LISTENER_URL", "CONNECTOR_TYPE", "AUTH_TOKENS"]);
export type MetaDataFieldType = keyof typeof MetaDataFieldType;

/**
 * Service Contribution Type
 * @type {{[K in string|string]:K}}
 */
export const ITCIServiceContributionType = strEnum(["Provider", "Handler"]);
export type ITCIServiceContributionType = keyof typeof ITCIServiceContributionType;

/**
 * Base Service Contribution
 */
export interface IBaseServiceContribution {
    /**
     *  Returns Type of contribution implementation , handler [[TCIServiceProviderContribution]] or provider [[TCIServiceHandlerContribution]]
     * @return {ITCIServiceContributionType}
     */
    getType(): ITCIServiceContributionType;
}

/**
 * Base Service Contribution
 */
export interface ITCIBaseServiceContribution {
    /**
     *  Returns Type of contribution implementation , handler [[WiServiceProviderContribution]] or provider [[WiServiceHandlerContribution]]
     * @return {IServiceContributionType}
     */
    getType(): ITCIServiceContributionType;
}

/**
 * Provider Service contribution interface
 */
export interface ITCIServiceProviderContribution extends ITCIBaseServiceContribution {
    /**
     * @description Returns the FieldProvider for a given field.
     * @example
     * ## Simple Example
     *
     * Here is an example of a field value provider class that can be injected:
     *
     * ```
     *
     *  @Injectable()
     *  export class Field1Provider extends AbstractContribFieldProvider {
     *   getFieldValue(context: IActivityContribution): Observable<string[]> {
     *      return Observable.create(observer => {
     *        observer.next("");
     *     });
     *  }
     * }
     *  @WiContrib({
     *   validationProviders: [
     *      {
     *          field: "field1",
     *          useClass: Field1ValidationProvider
     *      }
     *   ],
     *   fieldProviders: [
     *      {
     *       field: "field1",
     *       useClass: Field1Provider
     *      }
     *   ]
     * })
     *  @Injectable()
     * export class RestContribService extends WiServiceContribution {}
     * ```
     * @param {string} fieldName
     * @return {IContribFieldProvider}
     */
    getFieldProvider(fieldName: string): ITCIContribFieldProvider;

    /**
     * @description Returns the vrules provider for a given field.
     * @example
     * Here is an example of a vrules provider class that can be injected:
     *
     * ```
     *
     *  @Injectable()
     * export class Field1ValidationProvider extends AbstractContribValidationProvider {
     *      validate(context: IContributionContext): Observable<IValidationResult> {
     *          return Observable.create(observer => {
     *               let vresult: IValidationResult = ValidationResult.newValidationResult();
     *                      observer.next(vresult);
     *           });
     *      }
     * }
     *  @WiContrib({
     *   validationProviders: [
     *      {
     *          field: "field1",
     *          useClass: Field1ValidationProvider
     *      }
     *   ],
     *   fieldProviders: [
     *      {
     *       field: "field1",
     *       useClass: Field1Provider
     *      }
     *   ]
     * })
     *  @Injectable()
     * export class RestContribService extends WiServiceContribution {}
     * ```
     * @param {string} fieldName
     * @return {IContribValidationProvider}
     */
    getValidationProvider(fieldName: string): ITCIContribValidationProvider;

    /**
     * @description Returns the action provider for a given button field in the form.
     * @example
     * ## Simple Example
     *
     * Here is an example of a field value provider class that can be injected:
     *
     * ```
     *
     *  @Injectable()
     * export class Field1ActionProvider extends AbstractActionProvider {
     *   handleAction(context: IActivityContribution): Observable<string[]> {
     *      return Observable.create(observer => {
     *        observer.next("");
     *     });
     *  }
     * }
     *  @WiContrib({
     *   validationProviders: [
     *      {
     *          field: "field1",
     *          useClass: Field1ValidationProvider
     *      }
     *   ],
     *   fieldProviders: [
     *      {
     *       field: "field1",
     *       useClass: Field1Provider
     *      }
     *   ],
     *   actionProviders: [
     *      {
     *       field: "field1",
     *       useClass: Field1ActionProvider
     *      }
     *   ]
     * })
     *  @Injectable()
     * export class RestContribService extends WiServiceProviderContribution {}
     * ```
     *
     * @param {string} fieldName
     * @return {IContribActionProvider}
     */
    getActionHandler(fieldName: string): ITCIContribActionProvider;

    /**
     * @description Returns the action provider for a given button field in the form.
     * @example
     * ## Simple Example
     *
     * Here is an example of a field value provider class that can be injected:
     *
     * ```
     *
     *  @Injectable()
     * export class MyConnectionRemoveProvider extends AbstractContribRemoveProvider {
     *   handleRemove(context: IActivityContribution): Observable<string[]> {
     *      return Observable.create(observer => {
     *        observer.next("");
     *     });
     *  }
     * }
     *  @WiContrib({
     *   validationProviders: [
     *      {
     *          field: "field1",
     *          useClass: Field1ValidationProvider
     *      }
     *   ],
     *   fieldProviders: [
     *      {
     *       field: "field1",
     *       useClass: Field1Provider
     *      }
     *   ],
     *   actionProviders: [
     *      {
     *       field: "field1",
     *       useClass: Field1ActionProvider
     *      }
     *   ],
     *   removeProvider: MyConnectionRemoveProvider
     * })
     *  @Injectable()
     * export class RestContribService extends WiServiceProviderContribution {}
     * ```
     * @return {IContribRemoveProvider}
     */
    getRemoveProvider(): ITCIContribRemoveProvider;
}

/**
 * Handler Service contribution interface
 */
export interface ITCIServiceHandlerContribution extends IBaseServiceContribution, ITCIContributionHandler {
}

/**
 * Service contribution interface
 */
export interface ITCIServiceContribution extends ITCIServiceHandlerContribution, ITCIServiceProviderContribution {

}

/**
 *  DisplayField Type string enumeration
 * @type {{[K in string|string|string|string|string|string|string]:K}}
 */



export const TCIDisplayFieldType = strEnum(["connection", "dropdown", "table", "texteditor", "fileselector", "connectiondata", "button", "params", "password"]);
export type TCIDisplayFieldType = keyof typeof TCIDisplayFieldType;
/**
 *  WizardField Type string enumeration
 * @type {{[K in string|string|string|string|string|string|string]:K}}
 */
export const TCIWizardDisplayFieldType = strEnum(["connection", "dropdown", "table", "texteditor", "fileselector", "connectiondata", "button", "params",
    "selectButtons", "string", "number", "boolean", "complex_object", "array", "object", "integer"]);
export type TCIWizardDisplayFieldType = keyof typeof TCIWizardDisplayFieldType;
/**
 * Button Type string enumeration
 * @type {{[K in string|string|string]:K}}
 */
export const ButtonType = strEnum(["submit", "reset", "button"]);
export type ButtonType = keyof typeof ButtonType;
/**
 *  Button Style string enumeration
 * @type {{[K in string|string|string|string|string|string]:K}}
 */
export const ButtonStyle = strEnum(["default", "primary", "success", "info", "warning", "danger"]);
export type ButtonStyle = keyof typeof ButtonStyle;

export const AUTHENTICATION_TYPE = strEnum(["BASIC", "OAUTH1", "OAUTH2", "OAUTH2_TWOLEG"]);
export type AUTHENTICATION_TYPE = keyof typeof AUTHENTICATION_TYPE;

export const CONTRIB_PROXY_END_POINT = "/api/v1/contributions/proxy/";

/**
 * FieldType string enumeration
 * @type {{[K in string | string | string | string]:K}}
 */
export const TCIFieldType = strEnum(["string", "number", "boolean", "complex_object", "array", "object", "integer"]);
export type TCIFieldType = keyof typeof TCIFieldType;





/**
 * TCI Connector Contribution
 */
export interface ITCIConnectorContribution extends ITCIContributionContext {
    /**
     * Connector name. Must be unique, no spaces
     */
    name: string;
    /**
     *  Title to display on the connection tile
     */
    title: string;
    /**
     * Connector version. Must follow semver versioning
     */
    version: string;
    /**
     * Type of contribution flogo:activity or flogo:trigger or flogo:connector
     */
    type: string;
    /**
     * URI reference for connector
     */
    ref: string;
    /**
     * Provider the field name in settings section which will hold identifiable
     * name for the connection. In the absence of this keyfield the unique
     * connection record identifier e.g. uuid will be used for display.
     */
    keyfield: string;
    /**
     * Display Settings
     */
    display?: IContributionDisplay;
    /**
     * Static connector configurations e.g. connection name, connection description, connection configuration etc.
     *
     * FOR {{AUTHENTICATION_TYPE}} IS {{AUTHENTICATION_TYPE.OAUTH1 }} | {{AUTHENTICATION_TYPE.OAUTH2 }} | {{AUTHENTICATION_TYPE.OAUTH2_TWOLEG }}
     * FIXED ReEntry Field Name **WI_STUDIO_OAUTH_CONNECTOR_INFO** is mandatory.
     *
     * This field is not required for other Authentication purposes where it does not
     * involve a round trip to the third party auth system with a callback
     * The user can save all the required authentication tokens in this field which is
     * then used by the activity contribution developer to use this information.
     *
     * {
     *   "name" : "WI_STUDIO_OAUTH_CONNECTOR_INFO",
     *   "type" : "string",
     *   "display": {
     *      "visible": false
     *   }
     *  }
     */
    settings: ITCIFieldDefinition[];
    /**
     * Form Action configuration
     */
    actions: ITCIActionDefinition[];

    /**
     * Returns a field from inputs,outputs. Field Names must be unique within the activity
     * @param name
     */
    getField(name: string): ITCIFieldDefinition;

}

/**
 * interface ITCIActionDefinition
 */
export interface ITCIActionDefinition {
    /**
     * Unique name to identify the button. If display name is not provided name will be used.
     */
    name: string;
    /**
     * Button display settings
     */
    display?: ITCIFieldDisplay;
}

/**
 * Action item for button catalog
 */
export interface ITCIActionButton {
    name: string;
    actionId: string;
    display: ITCIFieldDisplay;
}


/**
 * Field display settings
 */
export interface ITCIFieldDisplay {
    /**
     * Named used in display
     */
    name?: string;
    /**
     * Display field type
     */
    type?: TCIDisplayFieldType;
    /**
     * Used with display field type dropdown
     */
    selection?: string;
    /**
     * Descrption for the field
     */
    description?: string;
    /**
     * Used with display field type fileselector
     */
    fileExtensions?: string[];
    /**
     * true when field is also shown in mapper, else false
     */
    mappable?: boolean;
    /**
     *  Used with display field type texteditor
     */
    syntax?: string;
    /**
     * Used with display field type table
     */
    schema?: string;
    /**
     * specifies if the field is visible , the field is always enabled. The default is true.
     */
    visible?: boolean;
    /**
     * Specifies the button type. Default type is "button"
     */
    buttonType?: ButtonType;
    /**
     * Button Styles when display type is button. Default style is "btn-default"
     */
    buttonStyle?: ButtonStyle;
    /**
     * Sets the widget in read-only mode
     */
    readonly?: boolean;
    /**
     * Indicates whether the field is valid or not
     */
    valid?: boolean;
    /**
     * specifies if the form field is exportable
     */
    exportable?: boolean;
    /**
     * specifies if the form field data is encryptable
     */
    encryptable?: boolean;

    // TODO: Connections are using this, need to revisit
    uri?: string;

    /**
     * Display in only mapper but not on input settings/ output settings even though there is display section
     */
    settings?: boolean;

    /**
     * Display in only Input Settings but not in mapper
     */
    inputSettingsOnly?: boolean;

    /**
     * Display in only Output Settings but not in output tree
     */
    outputSettingsOnly?: boolean;

    /**
     * Application Property Support , this is to be used with
     * fields showing primary data types i.e. number, boolean, string, date , time
     * and not for complex type
     */
    appPropertySupport?: boolean;
    /**
     * Determines if the user has choosed to substitute and app property for the field value.
     */
    appPropertyEnabled?: boolean;
}


/**
 * Display attributes for the contribution
 */
export interface IContributionDisplay {
    /**
     * display name for the contribution
     */
    name: string;
    /**
     * Specifies the category of the contribution e.g. Salesforce,Marketo , default is "Default"
     */
    category: string;
    /**
     * Specifies if a contribution is visible and enabled
     */
    visible?: boolean;
    /**
     * Specifies the small icon path. The path is relative to the contribution folder root. i.e. icons/file.png
     */
    smallIcon?: string;
    /**
     * Specifies the small icon path. The path is relative to the contribution folder root. i.e. icons/file.png
     */
    largeIcon?: string;
    /**
     * Description
     */
    description: string;
    /**
     * Sections for dynamic tabs
     */
    sections?: string[];
    /**
     * Step labels for trigger wizard display
     */
    wizard?: string[];
}

/**
 * Field Definition
 */
export interface ITCIFieldDefinition {
    /**
     * name of the field, not same as display name
     */
    name: string;
    /**
     * data type of the field in string e.g. string,number
     */
    type: TCIFieldType;
    /**
     * value of the field
     */
    value?: any;
    /**
     * specifies if the form field is required
     */
    required?: boolean;
    /**
     * specified allowed value for display field type "dropdown", keeping it same as flogo
     * For field display type == {{DisplayFieldType.connections}} then allowed property should
     * return array of {{IConnectionAllowedValue}}
     */
    allowed?: string[] | IConnectionAllowedValue[];
    /**
     * Used to place the field in a customized form tab section
     */
    section?: string;
    /**
     * Description
     */
    description: string;
    /**
     * Field display settings
     */
    display?: ITCIFieldDisplay;
    /**
     * Field display settings for wizard
     */
    wizard?: IFieldWizardDisplay;
}

/**
 * Field display settings for wizard
 */
export interface IFieldWizardDisplay {
    /**
     * Wizard Step Label
     */
    step: string;
    /**
     * Field Display Name to be shown on wizard page
     */
    name?: string;
    /**
     * Field Widget type
     */
    type?: string;
    /**
     * inline CSS for the field item
     */
    css?: any;
}

/**
 * @desc This interface defines the contract between the value provider of a field
 * whose display field type is {{DisplayFieldType.connection}}.
 */
export interface IConnectionAllowedValue {
    /**
     * @desc This is the unique id assigned to a new connection during creation
     * @example uuid
     */
    unique_id: string;
    /**
     * This is a name which is either calculated or provided via field value
     * in the connection JSON settings. In absence of name unique_id will be
     * used for display as a drop down choice.
     */
    name: string;
}

/**
 * Action Result implementation
 */
export class TCIActionResult implements ITCIActionResult {
    success: boolean;
    result: ITCIValidationError | ITCIAuthenticationResult | any;

    /**
     * static constructor
     * @param {ITCIValidationError | any} data
     * @return {ITCIActionResult}
     */
    static newActionResult(data?: ITCIValidationError | any): ITCIActionResult {
        return new TCIActionResult(data);
    }

    /**
     * @private
     * @param {ITCIValidationError | any} result
     */
    private constructor(result?: ITCIValidationError | any) {
        if (result) {
            this.result = result;
        }
    }

    /**
     * Returns if the action is successful or not
     * @return {boolean}
     */
    isSuccess(): boolean {
        return this.success;
    }

    /**
     * set success or failure boolean state
     * @param {boolean} state
     * @return {ITCIActionResult}
     */
    setSuccess(state: boolean): ITCIActionResult {
        this.success = state;
        return this;
    }

    /**
     * Set result data
     * @param {ITCIValidationError | any} result
     * @return {ITCIActionResult}
     */
    setResult(result?: ITCIValidationError | ITCIAuthenticationResult | any): ITCIActionResult {
        this.result = result;
        return this;
    }

    /**
     * get Result Data
     * @return {ITCIValidationError| ITCIAuthenticationResult | any}
     */
    getResult() {
        return this.result;
    }
}
